export type CliError<T extends string = string, D = unknown> = {
  code: T
  detail: D
}

export function createError<const T extends string, D>(
  code: T,
  detail: D,
): CliError<T, D> {
  return {
    code,
    detail,
  }
}

export function displayError(
  error: unknown,
  fallback = 'Unknown error occurred. Please contact support@scalar.com',
): string {
  try {
    if (error instanceof Error) {
      return error.message
    }

    if (typeof error === 'object') {
      return JSON.stringify(error)
    }

    if (typeof error === 'string') {
      return error
    }

    return fallback
  } catch {
    return fallback
  }
}
